import { useEffect, useState } from "react";

/* Shared live-match counts.
 *
 * The header already polls the three match endpoints, so the side menu
 * publishing its own poll would double the requests -- the same trap an
 * earlier pass had to undo for the odds feed. Instead the header pushes
 * what it has into this store and anything else subscribes, so the counts
 * appear in more than one place at no extra network cost.
 */

let counts = { cricket: 0, football: 0, tennis: 0 };
const listeners = new Set();

export const setLiveCounts = (next) => {
  const merged = { ...counts, ...next };
  // Bail on no-op writes; the header re-renders far more often than the
  // numbers actually change.
  if (
    merged.cricket === counts.cricket &&
    merged.football === counts.football &&
    merged.tennis === counts.tennis
  ) {
    return;
  }
  counts = merged;
  listeners.forEach((fn) => fn(counts));
};

export const getLiveCounts = () => counts;

export const useLiveCounts = () => {
  const [value, setValue] = useState(counts);
  useEffect(() => {
    // Pick up anything published between render and subscribe.
    setValue(counts);
    listeners.add(setValue);
    return () => listeners.delete(setValue);
  }, []);
  return value;
};

export default useLiveCounts;
